module.exports = __webpack_public_path__ + "static/media/canhemon_medium@2x.1c6753b5.jpg";